module.exports = __webpack_public_path__ + "img/Setting-Up-Product.e1bf592f.jpg";